import { Box, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import ActionsMenu from '../../comps/ActionMenu/ActionsMenu'
import EmptyView from '../../comps/EmptyView'
import { NewTable } from '../../comps/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { getWidth, useWindowDimensions } from '../../util/util'
import { styles } from './styles'
import { SubscriptionDetails } from './SubscriptionDetails'

const Subscriptions: FC = () => {
  const viewPortWidth = useWindowDimensions()

  const {
    getSubscriptionHistory,
    getSubscriptionList,
    getColumns,
    mid,
    selectedDateInfo,
    updateSelectedDate,
    applySubscriptionFields,
  } = useStores((store: any) => ({
    getColumns: store.subscriptions.getColumns,
    getSubscriptionHistory: store.subscriptions.getSubscriptionHistory,
    getSubscriptionList: store.subscriptions.getSubscriptionList,
    pageNumber: store.subscriptions.pagination.number,
    mid: store.user.selectedMid,
    selectedDateInfo: store.subscriptions.selectedDateInfo,
    updateSelectedDate: store.subscriptions.updateSelectedDateInfo,
    applySubscriptionFields: store.subscriptions.applySubFieldSettings,
  }))
  const [fetchSubscriptions, { state, data }] = useLazyApiData(getSubscriptionHistory)
  const themes = styles()
  const [fieldSettingVisible, setFieldSettingVisible] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)
  const [detailsVisible, setDetailsVisble] = useState(false)
  const [subscriptionId, setSubscriptionId] = useState('')

  useEffect(() => {
    if (mid !== '') {
      fetchSubscriptions()
    }
  }, [fetchSubscriptions, mid])

  const listData = [...getSubscriptionList()]

  useEffect(() => {
    getColumns()
    const savedFieldSettingData = window.localStorage.getItem('subscription_field_setting')
    if (savedFieldSettingData && savedFieldSettingData.length > 0) {
      applySubscriptionFields(JSON.parse(savedFieldSettingData))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getColumns])

  const scrollViewStyle = () => {
    if (listData.length === 0) {
      return themes.emptyContainer
    }
    return themes.tableContainer(false)
  }

  const onPress = (item: any) => {
    setSubscriptionId(item.id)
    setDetailsVisble(true)
  }

  // const onItemAction = () => {}

  const scrollStyle = scrollViewStyle()

  const fetchDetailOfPath = () => {
    fetchSubscriptions()
  }

  const closeDetails = () => {
    setDetailsVisble(false)
    setTimeout(() => {
      setSubscriptionId('0')
    }, 500)
  }
  const renderSubscriptionDetails = (): React.ReactElement => {
    return <SubscriptionDetails onDismiss={closeDetails} id={subscriptionId} />
  }

  const handleRetry = (): void => {
    fetchSubscriptions()
  }

  return (
    <Box
      {...themes.container}
      backgroundColor="WHITE"
      overflowY={fieldSettingVisible || filterVisible ? 'auto' : undefined}>
      <ModalDialog
        children={renderSubscriptionDetails()}
        show={detailsVisible}
        type={'Right'}
        onDismiss={closeDetails}
      />
      <Box marginTop={16}>
        <Text type="h0" color="BLACK_21" fontFamily="jioType-medium">
          {'Subscriptions'}
        </Text>
      </Box>
      <ActionsMenu
        path={'subscriptions'} //Should be subscriptions as its used to map pagination in actionsmenu
        fetchDetailOfPath={fetchDetailOfPath}
        fieldSettingVisible={fieldSettingVisible}
        setFieldSettingVisible={setFieldSettingVisible}
        filterVisible={filterVisible}
        setFilterVisible={setFilterVisible}
        fetchTxnColumns={getColumns}
        selectedDateInfo={selectedDateInfo}
        updateSelectedDate={updateSelectedDate}
        maxRange={31}
      />
      <EmptyView
        onRetry={handleRetry}
        isLoading={state === 'pending'}
        error={data?.message ?? false}
        emptyMessage={data?.message ?? 'No Subscriptions found'}
        loadingMessage={'Loading'}
        hide={listData.length > 0 && state !== 'pending'}
        loaderColor={'BLUE'}
      />
      <Spacer size={24} direction="vertical" />
      <Box {...scrollStyle} nativeID={'scroll-horizontal-Table'} f={1}>
        <NewTable
          data={listData.slice(1)}
          rowHeight={48}
          headerHeight={64}
          tableWidth={getWidth(viewPortWidth > 1200 ? viewPortWidth - 294 : viewPortWidth, listData[0])}
          headerRowKeys={listData && listData[0]}
          onRowClick={onPress}
          hide={filterVisible || fieldSettingVisible || !(listData?.length > 0) || state === 'pending'}
          sortBy="amount"
          freezeColumnWidth={200}
        />
      </Box>
    </Box>
  )
}

export default Subscriptions
